import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HalfByHalf from '../global/HalfByHalf';
import { Divider } from '@mui/material';
const StyledButton = styled('button')(({ theme }) => ({
    marginTop: '2rem',
    background: 'none',
    color: '#000',
    border: 'none',
    padding: '0',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    fontFamily: '"Oswald", sans-serif',
    display: 'inline-flex',
    alignItems: 'center', 
    cursor: 'pointer',
    textTransform:'uppercase',
    '&:hover span': {
      transform: 'translateX(10px)', 
    },
    '& span': {
      display: 'inline-flex',
      alignItems: 'center',
      marginLeft: '10px',
      transition: 'all 0.3s ', 
    },
  }));

const OverlayCard = styled('div')(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.78)',
  padding: '2rem 2.5rem',
  margin: '0 auto',
  [theme.breakpoints.down('sm')]: {
    padding: '1.5rem 1.25rem',
  },
}));

function BimHome(props) {
  const { t } = useTranslation('home');
    return (
      <HalfByHalf
        src="/img/offer/bim/bim.jpg"
        direction="left"
        alt="BIM"
        ratio={[7, 3]}
        minHeight="450px"
        contain={true}
        mobileOverlay={true}
      >
        <OverlayCard>
          <Typography variant="h4" sx={{ marginBottom: '1rem' }}>
            BIM
          </Typography>
          <Divider  width="50%" color="black"/>
          <Link to="/offer" style={{ textDecoration: 'none' }}>
            <StyledButton type="button">
              {t('learnMore')}
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
                  <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
                </svg>
              </span>
            </StyledButton>
          </Link>
        </OverlayCard>
      </HalfByHalf>
    );
}

export default BimHome;



